import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DeleteDrumModal = ({ show, onHide, drum, onConfirm, isLoading }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete drum{' '}
        <strong>{drum?.name || `${drum?.drumType} ${drum?.drumDiameter}`}</strong>?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={() => onConfirm(drum?._id)}
          disabled={isLoading}
        >
          {isLoading ? 'Deleting...' : 'Delete'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteDrumModal;
